import { getRegion } from '@/utils/stateAccessors';
import { FC, useMemo, type JSX } from 'react';
import './TaskDeadlineCompletionDateInformation.sass';

import { useSelector } from '@/api/state';
import DueMessage from '@payaca/components/dueMessage/DueMessage';
import LabelValuePair from '@payaca/components/labelValuePair/LabelValuePair';
import {
  DateFormats,
  getInternationalMomentDateFormatByRegion,
} from '@payaca/helpers/internationalHelper';
import { Task } from '@payaca/types/taskTypes';
import UntitledIcon from '@payaca/untitled-icons';
import moment from 'moment-timezone';

const renderCustomDueMessage = (dueInDays: number, message: string) => {
  const className =
    dueInDays == 0 ? 'today' : dueInDays > 0 ? 'future' : 'past';

  let icon = undefined;

  if (dueInDays > 0) {
    icon = <UntitledIcon name="clock.3" />;
  } else {
    icon = <UntitledIcon name="info-circle.3" />;
  }

  return (
    <div className={`task-due-message ${className}`}>
      {icon}
      <span>{message}</span>
    </div>
  );
};

type Props = {
  task: Task;
};
const TaskDeadlineCompletionDateInformation: FC<Props> = ({
  task,
}: Props): JSX.Element | null => {
  const region = useSelector(getRegion);

  const timestampRegionalFormat = useMemo(
    () => getInternationalMomentDateFormatByRegion(DateFormats.SHORT, region),
    [region]
  );

  if (!task.deadlineDate && !task.completedAt) return null;
  return (
    <div className={'task-deadline-completion-date-information'}>
      {!!task.deadlineDate && !task.completedAt && (
        <div className="flex-container flex-center">
          <LabelValuePair
            label={'Deadline date'}
            value={moment(task.deadlineDate).format(timestampRegionalFormat)}
          />
          {!task.completedAt && (
            <DueMessage
              dueDate={task.deadlineDate}
              renderMessage={renderCustomDueMessage}
            />
          )}
        </div>
      )}
      {!!task.completedAt && (
        <div className="">
          <LabelValuePair
            label={'Completed'}
            value={moment(task.completedAt).format(timestampRegionalFormat)}
          />
        </div>
      )}
    </div>
  );
};
export default TaskDeadlineCompletionDateInformation;
